import { Col } from 'components';

const Athlete = ({}) => {
  return <Col></Col>;
};

export default Athlete;
